import css from './DropdownButton.module.css';
import ThinArrowIcon from '../../../Icons/ThinArrowIcon';
import BasicButton, {
    BasicButtonProps,
} from '@shared/Ui/Buttons/BasicButton/BasicButton';
import classNames from 'classnames';

interface DropdownButtonProps extends Omit<BasicButtonProps, 'children'> {
    isOpen?: boolean;
    iconWidth?: number;
    iconHeight?: number;
    iconFill?: string;
    iconStroke?: string;
}

const DropdownButton: React.FC<DropdownButtonProps> = ({
    isOpen,
    className = css.dropdownBtn,
    iconWidth = 17,
    iconHeight = 9,
    iconStroke = 'currentColor',
    iconFill = 'none',
    ...rest
}) => {
    return (
        <BasicButton className={className} {...rest}>
            <ThinArrowIcon
                width={iconWidth}
                height={iconHeight}
                className={!isOpen ? css.closed : css.open}
                stroke={iconStroke}
                fill={iconFill}
            />
        </BasicButton>
    );
};

export default DropdownButton;
